/*
  Boston Breaks: The Vault (Phase D)
  - Display cases fade and rise in as they scroll into view.
  - The spotlight card tilts toward the pointer (desktop mouse only).
  Everything is progressive: without this script the cases are simply visible and still.
  "Reduce motion" turns both effects off. The vault door intro lives inline in
  sections/bb-vault.liquid so it never waits on this file.
*/
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var items = root.querySelectorAll('.bb-reveal');
    if (!items.length || reduceMotion || !('IntersectionObserver' in window)) return;

    root.classList.add('js-reveal');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index % 3, 2) * 90 + 'ms';
      observer.observe(item);
    });
  }

  function initTilt(root) {
    if (reduceMotion) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    root.querySelectorAll('[data-bb-tilt]').forEach(function (wrap) {
      var card = wrap.querySelector('.bb-vault-case');
      if (!card) return;

      wrap.addEventListener('mousemove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(1000px) rotateX(' + (-y * 8).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg) translateY(-6px)';
        wrap.classList.add('is-tilting');
      });
      wrap.addEventListener('mouseleave', function () {
        card.style.transform = '';
        wrap.classList.remove('is-tilting');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-bb-vault], [data-bb-vault-more]').forEach(function (root) {
      initReveal(root);
      initTilt(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
